import React from "react";
import "./Copyright.css";

const Copyright = (props) => (
    <div className={"copyright " + props.className}>
        <span>{props.text}</span>
    </div>
);

export default Copyright;